if (!customElements.get('fomo-message')) {
    class FomoMessage extends HTMLElement {
      constructor() {
        super();

        // Configuración desde atributos data
        this.subtitle = this.querySelector('.subtitle');
        this.showDelay = parseInt(this.getAttribute('data-time') || '3', 10) * 1000; // Convertir segundos a ms
        this.duration = parseInt(this.getAttribute('data-duration') || '17', 10) * 1000; // Convertir segundos a ms
        this.animationDuration = parseFloat(this.getAttribute('data-animation-duration') || '0.5'); // Duración de la animación (s)
        this.productId = this.dataset.productId;
        this.sectionId = this.dataset.sectionId;
        this.productHandle = this.dataset.productHandle;
        this.messageSpan = this.querySelector(`#fomo-${this.sectionId}`);
        this.cooldownPeriod = parseInt(this.getAttribute('data-cooldown-period') || '3600', 10) * 1000; // Convertir segundos a ms
        this.closeIcon = this.querySelector('.close-icon');

        // Inicialización
        this.init();
      }
  
      connectedCallback() {
        // Start updating every 5 seconds
        /* this.startUpdating(); */
      }
  
      disconnectedCallback() {
        // Clean up when element is removed
        /* if (this.updateInterval) {
          clearInterval(this.updateInterval);
        } */

        if (this.showTimeout) {
          clearTimeout(this.showTimeout);
        }
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
        }
      }

      init() {
        // Aplicar duración de animación desde atributos
        this.style.transition = `left ${this.animationDuration}s ease-in-out`;
        
        // Configurar evento de cierre
        if (this.closeIcon) {
          this.closeIcon.addEventListener('click', () => this.hide());
        }
        
        // Verificar si debemos mostrar el mensaje según el período de enfriamiento
        if (this.shouldShowMessage()) {
          // Mostrar mensaje después del delay
          this.showTimeout = setTimeout(() => {
            this.show();
            
            // Ocultar después de la duración especificada
            this.hideTimeout = setTimeout(() => {
              this.hide();
            }, this.duration);
          }, this.showDelay);
        }
      }

      /**
 * Genera una clave única para localStorage que almacenará todos los mensajes FOMO
 * @returns {string} Clave para localStorage
 */
getStorageKey() {
  return 'fomo_messages';
}

/**
 * Determina si el mensaje debe mostrarse basado en el tiempo transcurrido
 * desde la última vez que se mostró
 * @returns {boolean} true si el mensaje debe mostrarse
 */
shouldShowMessage() {
  if(!this.subtitle) return false;

  try {
    // Obtener datos almacenados o crear objeto vacío si no existe
    const data = JSON.parse(localStorage.getItem(this.getStorageKey()) || '{}');
    const lastShownTime = data[this.productId || 'global'];
    
    
    if (!lastShownTime) {
      return true; // Nunca se ha mostrado, así que debemos mostrarlo
    }
    
    // Calculando si ha pasado suficiente tiempo desde la última vez que se mostró el mensaje FOMO
    const now = Date.now();
    const timeSinceLastShown = now - lastShownTime;

    return timeSinceLastShown >= this.cooldownPeriod;
  } catch (e) {
    console.warn('Error al leer datos FOMO:', e);
    return true; // En caso de error, mostrar el mensaje
  }
}

show() {
  this.classList.add('active');
  
  try {
    // Obtener datos almacenados o crear objeto vacío si no existe
    const data = JSON.parse(localStorage.getItem(this.getStorageKey()) || '{}');
    
    // Guardar el tiempo en que se mostró el mensaje para este producto
    data[this.productId || 'global'] = Date.now();
    
    // Guardar el objeto actualizado
    localStorage.setItem(this.getStorageKey(), JSON.stringify(data));
  } catch (e) {
    console.warn('Error al guardar datos FOMO:', e);
  }
}
      
      hide() {
        this.classList.remove('active');
        
        // Limpiar temporizadores para evitar comportamientos inesperados
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }
      }
  
      /* startUpdating() {
        // Initial update
        this.updateSection();
        
        // Set interval for updates
        this.updateInterval = setInterval(() => {
          this.updateSection();
        }, 60000); // 5 seconds
      } */
  
      updateSection() {
        /* const url = `${Shopify.routes.root}products/${this.productHandle}?section_id=${this.sectionId}`;
        
        fetch(url)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newFomoMessage = html.querySelector(`fomo-message[data-product-id="${this.productId}"]`);
            console.log(newFomoMessage, 'newFomoMessage')
            if (newFomoMessage) {
              const newMessageSpan = newFomoMessage.querySelector(`#fomo-${this.sectionId}`);
              console.log(newMessageSpan)
              if (newMessageSpan && this.messageSpan.textContent !== newMessageSpan.textContent) {
                // Only update if content has changed
                this.messageSpan.innerHTML = newMessageSpan.innerHTML;
                
                // Add a subtle animation
                this.messageSpan.animate([
                  { opacity: 0.5, transform: 'translateY(5px)' },
                  { opacity: 1, transform: 'translateY(0)' }
                ], {
                  duration: 300,
                  easing: 'ease-out'
                });
              }
            } else {
              // If the message is no longer present (e.g., fell below minimum), remove the component
              this.remove();
            }
          })
          .catch(e => {
            console.error('Error updating FOMO message:', e);
          }); */
      }
    }
  
    customElements.define('fomo-message', FomoMessage);
  } 